import { render, staticRenderFns } from "./hotCoin.vue?vue&type=template&id=f06fa96a&scoped=true&"
import script from "./hotCoin.vue?vue&type=script&lang=js&"
export * from "./hotCoin.vue?vue&type=script&lang=js&"
import style0 from "./hotCoin.vue?vue&type=style&index=0&id=f06fa96a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06fa96a",
  null
  
)

export default component.exports